document.querySelectorAll(".variant_name").forEach(item => {
  var valueStr = item.getAttribute("value");
  if(!item.innerText && valueStr){
    var nums = valueStr.match(/\d+(.\d+)?/g);
    if(nums && nums.length > 0){
      item.innerText = valueStr.indexOf("Platinum") > -1 ? ("PT"+nums[0]):(nums[0] + " ct")
    }else{
      item.innerText = valueStr.indexOf("Platinum") > -1 ? "PT": "ct"
    }
  }
})